<template>
  <div class="content-main">
    <HeaderBar :text="info.header" :backgroundUrl="info.headerUrl"></HeaderBar>
    <div class="content">
      <div class="container">
        <div class="info-control">
          <div class="search-area">
            <div class="header-group">
              <i class="fa fa-search text-right" aria-hidden="true" style="padding: 0 5px;"></i>
              <span> : {{info.search}}</span>
              <input class="input" type="text" label="_" v-model="year">
            </div>
          </div>
          <div class="result-box">
            <div class="row head">
              <div class="col-6 text-center item head"><span>{{info.result[0]}}</span></div>
              <div class="col-6 text-center item"><span>{{info.result[1]}}</span></div>
            </div>
            <div class="row">
              <div class="col-6 text-center item head"><span><b>E</b></span></div>
              <div class="col-6 text-center item"><span>{{selectedResult[0]}}</span></div>
            </div>
            <div class="row">
              <div class="col-6 text-center item head"><span><b>S</b></span></div>
              <div class="col-6 text-center item"><span>{{selectedResult[1]}}</span></div>
            </div>
            <div class="row">
              <div class="col-6 text-center item head"><span><b>C</b></span></div>
              <div class="col-6 text-center item"><span>{{selectedResult[2]}}</span></div>
            </div>
          </div>
          <div class="update-area"><b>{{info.update[0]}}</b> : {{info.dateUpdate.semester}} ({{info.update[1]}} {{info.dateUpdate.date}})</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../COMMON/HeaderBar.vue'

export default {
  components: {
    HeaderBar
  },
  data () {
    return {
      year: '4',
      oldState: '4',
      selectedResult: []
    }
  },
  mounted () {
    this.selectedResult = this.info.data[0].results
  },
  methods: {
    getResult: function (year) {
      var result = this.info.data.find(el => {
        return el.year === year
      })

      this.selectedResult = result.results
    }
  },
  watch: {
    year: function (e) {
      this.year = e.substring(e.length - 1, e.length)
      if (this.year === '4' || this.year === '5' || this.year === '6') {
        this.oldState = this.year
        this.getResult(this.year)
      } else {
        this.year = this.oldState
      }
    }
  },
  props: ['info', 'langData']
}
</script>

<style scoped>

  .content-main {
    padding-bottom: 60px 0;
    background-color: rgba(200, 200, 200, 0.3);
  }

  .content {
    padding: 60px 0;
  }

  .info-control {
    width: 60%;
    margin: auto;
  }

  @media screen and (max-width: 991px) {
    .info-control {
      width: 80%;
    }
  }

  @media screen and (max-width: 575px) {
    .info-control {
      width: 100%;
    }
  }

/* ------------------ Seach Box -------------------- */

  .search-area {
    background: transparent;
    padding: 15px 0px 15px 30px;
    text-align: right;
    box-shadow: 0 4px 2px -1px rgba(255, 60, 0, 0.3);
  }

  .header-group span, .header-group input, .header-group .fa {
    font-size: 24px;
    color: #FFA500;
  }

  .input {
    border: none;
    background: transparent;
    padding-bottom: 0;
    border-bottom: 2px solid #FFA500;
    width: 2em;
    text-align: center;
    line-height: 1;
  }

  .input:focus{
    outline: none;
  }

  @media screen and (max-width: 575px) {
    .search-area {
      padding: 18px;
    }

    .header-group span, .header-group input, .header-group .fa {
      font-size: 22px;
    }

    .input {
      width: 1em;
    }
  }

/* -------------------- Result Box ----------------------*/

  .result-box {

  }

  .result-box .row {
    margin: 0;
  }

  .result-box .row:nth-child(even) {
    background-color: #FFF;
    border-left: 0.5px solid rgba(35, 35, 35, 0.4);
    border-right: 0.5px solid rgba(35, 35, 35, 0.4);
  }

  .result-box .row:first-child {
    border: 0.5px solid rgba(35, 35, 35, 0.4);
    background-color: #FFA500;
  }

  .result-box .row:last-child {
    border-bottom: 0.5px solid rgba(35, 35, 35, 0.4);
  }

  .result-box .row:first-child span{
    color: #FFF;
    font-weight: 500;
  }

  .result-box .row:nth-child(odd):not(:first-child) {
    background-color: rgba(255, 198, 25, 0.7);
    border-left: 0.5px solid rgba(35, 35, 35, 0.4);
    border-right: 0.5px solid rgba(35, 35, 35, 0.4);
  }

  .result-box .item {
    padding: 7.5px;
  }

  .result-box .item:nth-child(odd){
    border-right: 0.5px solid rgba(35, 35, 35, 0.4);
  }

/* -------------------- Update Area ----------------------*/

  .update-area {
    padding-top: 15px;
    font-size: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Info.vue